/*--------------------------------------------------
Script name: 	   CG Main
Author:			   Craig Collins, Ashley Robbins, Martin Doychinov, Louie Colgan
Version:		   0.1
Created:	       07/12/2015
Notes:             Main JavaScript file for C&G.com widgets page
References:        BigBird-level5.1.0.0.js, interact.1.0.0.js, core.1.0.1.js
------------------------------------------------*/
$(window).on("load", function (e) {

    if (!$('.scChromeToolbar').length) {

       
        /* 1. IMAGE TEXT WIDGET EQUAL HEIGHTS
        ------------------------------------------*/
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

        $('.equalHeights > div').each(function () {
            $el = $(this);
            topPosition = $el.position().top;
            if (currentRowStart != topPosition) {
                // we just came to a new row.  Set all the heights on the completed row
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                // set the variables for the new row
                rowDivs.length = 0; // empty the array
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                // another div on the current row.  Add it to the list and check if it's taller
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            // do the last row
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        }
        );
        

    /* 4. ACCORDION
    ------------------------------------------*/
    var accordion = new interact.accordion({
        wrapper: '.accordionWrapper',
        selector: '.accordionTitle',
        multiOpen: true,
        checkUrl: true,
        active: false
    });
    
        

        /* 18. TEXTWIDGET ACCORDION
        ------------------------------------------*/
        $('.textwidget_title').on('click', function () {
            $(this).closest('.textwidget').toggleClass('open');
        });

        $('a').on('click', function (e) {
            for (var i = 0; i < $(this).length; i++) {
                setTimeout(function () {
                    if (window.location.hash) {
                        if (!$(window.location.hash).hasClass("open")) {
                            // click on the accordion.
                            $(window.location.hash).trigger('click');
                        }
                    }
                }, 100);
            }
        });

        /* 19. CLEAR OUT EMPTY DIVS FROM WIDGETWRAPPER
        ------------------------------------------*/
        $('.widgetWrapper > .marginBottomDouble').each(function () {
            if ($(this).html().length < 1) {
                $(this).remove();
            }
        });

       

        /* 21. TAB LIST ACCORDION  
------------------------------------------*/
        $('.tab-list--item a').on('click', function (e) {
            e.preventDefault();
            var container = $(this).closest('.tab-component');

            container.find('.tab-list--item.active').removeClass('active');
            $(this).parent('li').addClass('active');

            var tabItem = $(this).attr('data-tab');
            var panelItem = container.find(".tab-list--content").find("[data-panel='" + tabItem + "']");
            container.find('.tab-list--panel.active').removeClass('active');
            panelItem.addClass('active');
        });

        if ($('.tab-list').length) {
            $('.tab-list').each(function () {
                $(this).find('.tab-list--item').first().find('a').click();
            });
        }
        
        /* 21.1 TAB LIST ACCORDION - HASH CHECKING
------------------------------------------*/
        $(document).ready(function () {
            if (window.location.hash) {
                // only do this if there's a tab-list on the page, otherwise do the usual anchor behaviour
                if ($('.tab-list').length) {
                    var hash = decodeURIComponent(window.location.hash.substr(1));
                    var tabNumber = hash.slice(-1) - 1;
                    $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

                    var $container = $("html,body");
                    var $scrollTo = $('.tab-list');

                    window.location.hash = '';

                    $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);

                }
            }
        });

        /* 21.2 TAB LIST ACCORDION - ON PAGE LINKS
------------------------------------------*/
        $(document).ready(function () {
            $('.js-tab-link').on('click', function () {
                //console.group('click');
                var hash = this.hash;
                //console.group(hash);
                var tabNumber = hash.slice(-1) - 1;
                //console.groupEnd(tabNumber);
                $(".tab-list .tab-list--item:eq(" + tabNumber + ")").find('a').click();

                var $container = $("html,body");
                var $scrollTo = $('.tab-list');

                $container.animate({ scrollTop: $scrollTo.offset().top - 100 - $container.offset().top + $container.scrollTop(), scrollLeft: 0 }, 300);
            });
        });
        
    } //if ($('.scChromeToolbar').length) {
    
});